import { fetch } from '@atlassian/eoc-fetch';
export const getNotificationPreferences = () => fetch(`/v1/users/notification-preferences`);
export const getContact = () => fetch(`/v1/users/contact`);
export const getMuteDetail = () => fetch(`/v1/users/notifications/mute`);
export const getQuietHoursDetail = () => fetch(`/v1/users/quiet-hours/details`);
export const getForwardingRules = () => fetch(`/v1/alerts/notifications/forwarding-rules`);